import { hexToRgba } from '../../shared/theme/colorUtils';
import type { ThemeColors } from '../../shared/theme/store';
import type { LoadMainPalette } from './types';

export function resolveLoadMainPalette(
  colors: ThemeColors,
  appearance: 'light' | 'dark',
  color?: string,
  track_color?: string,
): LoadMainPalette {
  const primary = color ?? colors.primary;
  const track =
    track_color ??
    (appearance === 'dark'
      ? hexToRgba(colors.surfaceFade, 0.55)
      : hexToRgba(colors.borderLight, 0.9));
  const secondary = colors.textSecondary;

  return {
    primary,
    track,
    secondary,
    glow: hexToRgba(primary, appearance === 'dark' ? 0.22 : 0.14),
    highlight: hexToRgba(primary, appearance === 'dark' ? 0.55 : 0.38),
  };
}
